import { Card, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled("div")`
    padding: 10px 20px 20px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ActiveSessionContainer = styled(Card)`
    display: flex;
    width: 100%;
    background-color: ${({ theme }) => theme.palette.secondary.main};
    padding: 20px 20px 10px 20px;
    align-items: center;
    justify-content: space-between;
`;

export const HeaderButtons = styled("div")`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px 0 20px;
`;

export const ExerciseName = styled(Typography)`
    color: ${({ theme }) => theme.palette.primary.main};
`;

export const MediaContainer = styled("div")`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const StyledImage = styled("img")`
    width: 100%;
    height: auto;
`;

export const StyledVideo = styled("video")`
    max-height: 500px;
    max-width: 98vw;
`;

export const ExerciseCountWrapper = styled("div")`
    display: flex;
    align-items: center;
`;

export const ContentWrapper = styled("div")`
    border: 1px solid #000;
    border-radius: 4px;
    overflow: hidden;
`;

export const WebcamWrapper = styled(ContentWrapper)`
    max-width: 400px;
    max-height: 400px;
    aspect-ratio: 1 / 1;
`;

export const GeneratedExerciseWrapper = styled(ContentWrapper)`
    width: 100%;
    padding: 8px;
`;

export const SectionWithSeparator = styled("div")`
    width: 100%;
    border-top: 1px solid #000;
`;
